import { Chip } from "@mui/material";

const TabLabel = ({ label, count }) => {
  return (
    <div className="transmission-table__tab-label">
      {label}
      {count > 0 && (
        <div style={{ marginLeft: "8px" }}>
          <Chip label={count} color="secondary" />
        </div>
      )}
    </div>
  );
};

export default TabLabel;
